'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var InputWithTopLabel = require('../InputWithTopLabel/InputWithTopLabel.js');
var SelectWithTopLabel = require('../SelectWithTopLabel/SelectWithTopLabel.js');
var styledComponents = require('./styled-components.js');

var InputWithLeftMenu = function (props) {
    var defaultSelectedValue = props.defaultSelectedValue, _a = props.defaultTextValue, defaultTextValue = _a === void 0 ? '' : _a, menuItems = props.menuItems, inputPlaceholder = props.inputPlaceholder, selectPlaceholder = props.selectPlaceholder, reporter = props.reporter, _b = props.selectWidth, selectWidth = _b === void 0 ? 'inherit' : _b;
    var initialSelectedValue = function () {
        if (defaultSelectedValue)
            return defaultSelectedValue;
        if (selectPlaceholder)
            return undefined;
        return menuItems[0].value;
    };
    var _c = React.useState(initialSelectedValue()), selectedValue = _c[0], setSelectedValue = _c[1];
    var _d = React.useState(defaultTextValue), textValue = _d[0], setTextValue = _d[1];
    var updateSelectedItem = function (newValue) {
        setSelectedValue(newValue);
        reporter({ selectedValue: newValue, textValue: textValue });
    };
    var updateInputText = function (newValue) {
        setTextValue(newValue);
        reporter({ selectedValue: selectedValue || '', textValue: newValue });
    };
    return (React__default.createElement(styledComponents.StyledPaper, null,
        React__default.createElement(styledComponents.SelectContainer, { style: { width: selectWidth } },
            React__default.createElement(SelectWithTopLabel, { defaultValue: selectedValue, menuItems: menuItems, reporter: updateSelectedItem, placeholder: selectPlaceholder })),
        React__default.createElement(styledComponents.InputContainer, null,
            React__default.createElement(InputWithTopLabel, { placeholder: inputPlaceholder, value: textValue, reporter: updateInputText, error: false, fullWidth: true }))));
};

module.exports = InputWithLeftMenu;
